import React, { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useGetProfileQuery } from '../slices/userApiSlice';
import {
  Container,
  Row,
  Col,
  Button,
  Spinner,
  Alert,
  Card,
} from 'react-bootstrap';
import { useEffect } from 'react';

const ProfileScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { data: user, isLoading, isError, error, refetch } = useGetProfileQuery();

  // Check for reload flag in state
  useEffect(() => {
    if (location.state?.reload) {
      refetch();
    }
  }, [location.state?.reload]);

  const handleUpdateProfile = () => {
    navigate('/update-profile');
  };

  const handleBackToHome = () => {
    navigate('/');
  };

  if (isLoading) {
    return (
      <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <Spinner animation="border" variant="primary" />
      </Container>
    );
  }

  if (isError) {
    return (
      <Container className="mt-5">
        <Alert variant="danger">
          Error fetching profile: {error?.data?.message || 'Unknown error'}
        </Alert>
      </Container>
    );
  }

  return (
    <Container className="my-4">
      <Button variant="link" onClick={handleBackToHome} className="mb-3">
        ← Back to Home
      </Button>

      <h2 className="mb-4">Profile</h2>

      <Row>
        <Col md={6}>
          <strong>Name:</strong>
          <p>{user.name}</p>

          <strong>Email:</strong>
          <p>{user.email || '-'}</p>

          <strong>Phone:</strong>
          <p>{user.phone}</p>

          <strong>Role:</strong>
          <p>{user.role}</p>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col>
          <h5>Addresses:</h5>
          {user.addresses && user.addresses.length > 0 ? (
            user.addresses.map((address, index) => (
              <Card key={index} className="mb-3">
                <Card.Body>
                  <Card.Text>
                    {address.address}, {address.city}, {address.pincode}
                  </Card.Text>
                  <Card.Text>
                    <strong>Phone:</strong> {address.phoneNumber || '-'}
                  </Card.Text>
                </Card.Body>
              </Card>
            ))
          ) : (
            <p>No addresses available</p>
          )}
        </Col>
      </Row>

      {user.role === 'vendor' && (
        <Row className="mt-4">
          <Col md={6}>
            <h5>Vendor Details</h5>
            <p><strong>GST Number:</strong> {user.gstNumber || '-'}</p>
            <p><strong>Shop Name:</strong> {user.vendorDetails?.shopName || '-'}</p>
            <p><strong>Commission %:</strong> {user.vendorDetails?.commissionPercentage ?? '-'}</p>
          </Col>
        </Row>
      )}

      <Row className="mt-4">
        <Col>
          <Button variant="primary" onClick={handleUpdateProfile}>
            Update Profile
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default ProfileScreen;
